function Slideshow(options = {}) {
    this.$wrapper = options?.wrapper ?? $('.js-slideshow');
    this.slidesClass = options?.slidesClass ?? 'js-slides';
    this.slideClass = options?.slideClass ?? 'js-slide';
    this.objectsClass = options?.objectsClass ?? 'js-objects';
    this.objectClass = options?.objectClass ?? 'js-object';
    this.captionClass = options?.captionClass ?? 'js-caption';
    this.slides = options?.slides || [];
    this.delay = options?.delay ?? 4000;
    this.initial = options?.initial ?? 1000;
    this.loop = options?.loop ?? true;

    this.template = options?.template ?? false;

    console.log(this.loop);

    this.slideConfig = options?.slide || {};
    this.captionConfig = options?.caption || {};

    this.isPaused = true;

    this.currentIndex = 0;
    this.total = this.slides.length;
    this.items = [];

    this.setup();
}

Slideshow.prototype.setup = function() {
    this.$body = $('body');

    this.$slideshow = this.$wrapper ? this.$wrapper : this.$body.find('.js-slideshow');
    this.$slidesWrapper = this.$slideshow.find(`.${this.slidesClass}`);
    this.$slides = this.$slideshow.find(`.${this.slideClass}`);

    this.total = this.$slides.length;
    // const meta = this.getMeta();

    this.$slides.each((i, slide) => {
        const $this = $(slide);

        const $objects = $this.find(`.${this.objectsClass}`);
        const $object = $this.find(`.${this.objectClass}`);
        const $caption = $this.find(`.${this.captionClass}`);

        const objects = [];
        $object.each((index, item) => {
            const $this = $(item);

            const object = {
                $element: $this,
                from: $this.data('from'),
                to: $this.data('to'),
            }

            objects.push(object);
        });

        const item = {
            $wrapper:  $this,
            $caption:  $caption,
            $objects:  $objects,
            $object:   $object,
            objectDom: $object.get(),
            objects:   objects,
            timeline: gsap.timeline({ paused: false,  }),
        }

        const offsetWidth = item.$wrapper.width() - ((item.$wrapper.width() - item.$objects.width()) / 2);

        this.slideConfig = {
            on: {
                from: {
                    x: -1 * offsetWidth,
                    opacity: 0, ...this.slideConfig.on.from
                },
                to: {
                    x: 0,
                    opacity: 1,
                    stagger: this.slideConfig.on?.stagger || null,
                    delay: this.slideConfig.on?.delay || 0,
                    duration: this.slideConfig.on?.duration || 1,
                    ease: this.slideConfig.on?.ease || 'expo.inOut',
                    ...this.slideConfig.on.to
                },
            },
            off: {
                from: {
                    x: 0,
                    opacity: 1,
                    ...this.slideConfig.off.from
                },
                to: {
                    x: offsetWidth,
                    opacity: 0,
                    stagger: this.slideConfig.off?.stagger || null,
                    delay: this.slideConfig.off?.delay || 0,
                    duration: this.slideConfig.off?.duration || 1,
                    ease: this.slideConfig.off?.ease || 'expo.inOut',
                    ...this.slideConfig.off.to
                },
            },
        }

        this.captionConfig = {
            on: {
                from: { ...this.captionConfig.on.from },
                to: {
                    stagger: this.captionConfig.on?.stagger || null,
                    delay: this.captionConfig.on?.delay || 0,
                    duration: this.captionConfig.on?.duration || 1,
                    ease: this.captionConfig.on?.ease || 'expo.inOut',
                    ...this.captionConfig.on.to,
                },
                position: this.captionConfig.on?.position || '<',
            },
            off: {
                from: { ...this.captionConfig.off.from },
                to: {
                    stagger: this.captionConfig.off?.stagger || null,
                    delay: this.captionConfig.off?.delay || 0,
                    duration: this.captionConfig.off?.duration || 1,
                    ease: this.captionConfig.off?.ease || 'expo.inOut',
                    ...this.captionConfig.off.to,
                },
                position: this.captionConfig.off?.position || '<',
            },
        }

        let target = item.$objects;
        if(this.slideConfig?.element === 'object') target = item.$object;
        else if (this.slideConfig?.element) target = item.$wrapper.find(this.slideConfig?.element);

        item.on = () => {
            if (item.$object && item.$object.length) {
                item.timeline.fromTo(
                    item.$object,
                    this.slideConfig.on.from,
                    this.slideConfig.on.to,
                );
            }
            if (item.$caption && item.$caption.length) {
                item.timeline.fromTo(
                    item.$caption.get(),
                    this.captionConfig.on.from,
                    this.captionConfig.on.to,
                    this.captionConfig.on.position
                );
            }
        }
        item.off = () => {
            if (item.$object && item.$object.length) {
                item.timeline.fromTo(
                    item.$object,
                    this.slideConfig.off.from,
                    this.slideConfig.off.to,
                );
            }
            if (item.$caption && item.$caption.length) {
                item.timeline.fromTo(
                    item.$caption.get(),
                    this.captionConfig.off.from,
                    this.captionConfig.off.to,
                    this.captionConfig.off.position
                );
            }
        }

        this.items.push(item);
    });




   this.onVisibilityChangeEvent = () => {
        const isVisible = !document.hidden;
        console.log("Is minimized?", isVisible);
        if(isVisible) this.play();
        else this.pause();
    }

    this.resizeTimeout = null;
    this.onResizeEvent = () => {
        console.log("Resizing!");
        this.pause();

        // ScrollTrigger.refresh();

        if(this.resizeTimeout) clearTimeout(this.resizeTimeout);

        this.resizeTimeout = setTimeout(() => {
            this.play();
            console.log("Stopped resizing!");
        }, 1000);
    }

    window.addEventListener("visibilitychange", this.onVisibilityChangeEvent);
    window.addEventListener("resize", this.onResizeEvent);


    this.videoController = new VideoController();
    this.videoController.$process(this.$slideshow);
}


Slideshow.prototype.next = function() {
    const currItem = this.items[this.currentIndex];
    this.currentIndex++;
    this.currentIndex = this.currentIndex % this.total;
    const nextItem = this.items[this.currentIndex];

    if(currItem) currItem.off();
    if(nextItem) nextItem.on();
}

Slideshow.prototype.run = function() {
    if(this.isPaused) return;
    if(this.playTimeout) clearTimeout(this.playTimeout);
    if(this.loop) {
        this.playTimeout = setTimeout(() => {
            this.next();
            this.run();
        }, this.delay);
    } else{
        this.next();
    }
}

Slideshow.prototype.pause = function() {
    if(this.playTimeout) clearTimeout(this.playTimeout);
    this.isPaused = true;
}

Slideshow.prototype.play = function() {
    if(this.initial === false) return;
    this.isPaused = false;

    if(this.playTimeout) clearTimeout(this.playTimeout);

    this.playTimeout = setTimeout(() => {
        this.next();
        this.run();
    }, this.initial);
}

Slideshow.prototype.destroy = function() {
    window.removeEventListener("visibilitychange", this.onVisibilityChangeEvent);
    window.removeEventListener("resize", this.onResizeEvent);
    // ScrollTrigger.killAll();
}
